'use client';

import { Clipboard } from 'lucide-react';
import { ReactNode } from 'react';
import { toast } from 'react-hot-toast';
import clsx from 'clsx';

export interface ClipboardCopyT {
  copied: string;
}

export function ClipboardCopy({
  copyText,
  copyContent,
  buttonContent = <Clipboard size={24} />,
  buttonClass,
  className,
  disabled,
  t,
}: {
  copyText?: string;
  copyContent: string;
  buttonContent?: ReactNode;
  buttonClass?: string;
  className?: string;
  disabled?: boolean;
  t: ClipboardCopyT;
}) {
  // This is the function we wrote earlier
  async function copyTextToClipboard(text: string) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  // onClick handler function for the copy button
  const handleCopyClick = () => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard(copyContent)
      .then(() => {
        // If successful, update the isCopied state value
        toast.success(t.copied, { id: copyContent });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  if (!copyText) {
    return (
      <button
        type="button"
        disabled={disabled}
        className={clsx(buttonClass, !disabled && 'cursor-pointer')}
        onClick={handleCopyClick}
      >
        {buttonContent}
      </button>
    );
  }

  return (
    <div className={clsx('flex items-center gap-2', className)}>
      {copyText && <input type="text" className="input w-full" value={copyText} readOnly />}
      {/* Bind our handler function to the onClick button property */}
      <button
        type="button"
        disabled={disabled}
        className={clsx(buttonClass, !disabled && 'cursor-pointer')}
        onClick={handleCopyClick}
      >
        {buttonContent}
      </button>
    </div>
  );
}
